import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base/base.component";
import {ActivatedRoute} from "@angular/router";
import {ShopService} from "../../../services/shop/shop.service";
import {Product} from "../../../models/shop/product";
import {Category} from "../../../models/category";
import Swal from "sweetalert2";
import {ProductCategory} from "../../../models/shop/productCategory";
import {ProductImage} from "../../../models/shop/ProductImage";
import {Parent} from "../../../models/parent";

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent extends BaseComponent implements OnInit {

  productId?: string | null;
  product: Product = new Product();
  categoriesList: Category[] = [];
  selectedCategories: ProductCategory[] = []
  imagesUrl: any[] = [];
  images: ProductImage[] = [];
  editPage?: string | null;
  companyId: string = localStorage.getItem('wisper_companyId') ?? '';
  usersDropdownSettings: any = {};
  wysiwygConfig = {
    setReadOnly: false,
    readonly: false,
    toolbar: true,
  };

  constructor(public serviceInjector: Injector,
              public shopService: ShopService,
              private router: ActivatedRoute) {
    super(serviceInjector);
  };

  async ngOnInit() {
    this.router.queryParamMap.subscribe(queryParams => {
      this.productId = queryParams.get('productToEdit');
      this.editPage = queryParams.get('pageType');
    });

    this.loadData();

    this.usersDropdownSettings = {
      idField: 'id',
      textField: "name",
      allowSearchFilter: true,
    };
  }

  goBack() {
    this.previousPage()
  }

  loadData() {
    this.showSpinner();
    if (this.productId) {
      this.shopService.getProductById(this.productId).then(async (res: any) => {
        if (res.success) this.product = res.data;
        if (this.product.images) {
          this.imagesUrl = this.product.images.map((item: any) => item.imageUrl);
        }
        this.selectedCategories = this.product.categories ?? [];

        this.images = this.product.images ?? [];
      });
    }
    this.shopService.getCategories(this.companyId).subscribe((res: any) => {
      if (res.success) this.categoriesList = res.data;
    })
    this.hideSpinner();
  }

  addImages(newImages: ProductImage[]) {
      this.images.push(...newImages);
      const newImageUrls = newImages.map(item => item.imageUrl);
      this.imagesUrl.push(...newImageUrls);
  }

  async chooseImage(event: any) {
    const images = event.target.files;
    const formData = new FormData();

    for (let i = 0; i < images.length; i++) {
      formData.append('files', images[i])
    }

    this.spinner.show();
    const {success, data} = await this.shopService.uploadImage(formData);
    if (success) {
      this.spinner.hide();
      this.addImages(data);
    }
  }

  onImageDeleted(deletedImageUrl: string) {
        const index = this.imagesUrl.findIndex(url => url === deletedImageUrl);
        if (index !== -1) {
            this.imagesUrl.splice(index, 1);
            if (this.images[index]) {
                this.images.splice(index, 1);
            }
        }
    }

  productValidation(product: Product) {
    return(
        product.name &&
        product.shortDescription &&
        product.description &&
        product.fullPrice &&
        (this.selectedCategories &&
            this.selectedCategories.length > 0) &&
        this.imagesUrl.length > 0
    )
  }

  async addProduct(productToAdd: Product) {
    this.showSpinner();

    productToAdd['companyId'] = this.companyId
    productToAdd['images'] = this.images
    productToAdd['categories'] = this.selectedCategories.map(category => ({ id: category.id } as ProductCategory));
    let response = await this.shopService.addProduct(productToAdd);

    if (response.success) {
      this.spinner.hide();
      Swal.fire({
        icon: 'success',
        title: 'Prodotto aggiunto con successo'
      }).then(() => {
        this.goBack();
      });

    } else {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: "Errore, riprova ad aggiungere il prodotto"
      });
    }
  }

  async editProduct(productToEdit: Product) {
    this.showSpinner();

    productToEdit['companyId'] = this.companyId
    productToEdit['images'] = this.images
    productToEdit['categories'] = this.selectedCategories.map(category => ({ id: category.id } as ProductCategory));

    let response = await this.shopService.editProduct(productToEdit);

    if (response.success) {
      this.spinner.hide();
      Swal.fire({
        icon: 'success',
        title: 'Prodotto modificato con successo'
      }).then(() => {
        this.goBack();
      });
    } else {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: "Errore, riprova a modificare il prodotto"
      });
    }
  }

  async uploadProductImage(event: any) {
    this.showSpinner();
    try {
      const coverImg = event?.target?.files[0];

      if (!coverImg) return;

      const formData = new FormData();
      formData.append('file', coverImg);

      const response: any = await this.shopService.uploadProductImage(formData);

      if (response.success) {
        this.showSuccessMessage('Immagine caricata con successo');
        this.product.coverImage = response.data;
      } else {
        this.showErrorMessage('Errore, riprova a caricare l\'immagine');
      }
    } catch (e) {
        this.showErrorMessage('Errore, riprova a caricare l\'immagine');
    }
    this.hideSpinner();
  }

  removeCoverImage() {
    this.product.coverImage = '';
  }

}
